"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateMinDimensions = exports.validateMaxFileSize = exports.validateFileType = void 0;
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
var _helpers = require("./helpers");
var _constants = require("./constants");
var validateMinDimensions = exports.validateMinDimensions = function validateMinDimensions(minWidth, minHeight, minDimension) {
  return function (_ref) {
    var originalImageInfo = _ref.originalImageInfo;
    if (!originalImageInfo) return;
    var width = originalImageInfo.width,
      height = originalImageInfo.height;
    var invalidMinDimension = !!minDimension && width < minDimension && height < minDimension;
    var invalidMinWidthOrHeight = minWidth && width < minWidth || minHeight && height < minHeight;
    if (invalidMinDimension || invalidMinWidthOrHeight) {
      throw new Error('dimensions');
    }
  };
};
var validateMaxFileSize = exports.validateMaxFileSize = function validateMaxFileSize(max) {
  return function (_ref2) {
    var size = _ref2.size;
    if (size !== null && (0, _helpers.bytesToMB)(size) >= max) {
      // Each argument in the Error constructor is a key in your locale file. Such keys are
      // mapped to messages shown to your users.The keys and messages can either be predefined like size, image,
      // or custom.
      throw new Error('size');
    }
  };
};
var validateFileType = exports.validateFileType = function validateFileType(acceptTypes) {
  return function (fileInfo) {
    var mimeType = fileInfo.mimeType;
    if (mimeType) {
      // New files, not yet in uploadcare don't have the mime type yet
      var allowedMimeTypes = acceptTypes.reduce(function (currentMimeTypes, acceptType) {
        var mimeTypesForAcceptType = _constants.ACCEPT_TYPE_TO_MIME_TYPE[acceptType];
        return currentMimeTypes.concat(mimeTypesForAcceptType);
      }, []);

      // Requires IE11 polyfill
      if (allowedMimeTypes.includes(mimeType)) {
        return;
      }

      // Each argument in the Error constructor is a key in your locale file. Such keys are
      // mapped to messages shown to your users.The keys and messages can either be predefined like size, image,
      // or custom.
      throw new Error('upload'); //  'Can’t upload' until it gets customized
    }
  };
};